import type { ValidationConfig } from '../../../core/dataProcessor/types';

// 🆕 为新 ValidationEngine 导出的配置
export const funnelValidationConfig: ValidationConfig = {
  fields: [
    { field: 'x', type: 'string', required: true },
    { field: 'y', type: 'number', required: true }
  ],
  businessRules: [
    {
      name: 'funnel-sufficient-data',
      validator: data => Array.isArray(data) && data.length > 1,
      message: 'Funnel chart requires more than 1 data point to display properly',
      suggestion: 'Provide at least 2 data points to create a meaningful funnel visualization',
      // 推荐性建议，不影响图表渲染
      severity: 'warning'
    }
  ]
};
